import { useEffect, type ReactNode } from 'react';

// Clases compartidas para formularios dentro de modales (consistencia visual).
export const inputCls =
  'w-full px-3 py-2 text-sm border border-background-200 rounded-md bg-white text-foreground-800 focus:outline-none focus:ring-2 focus:ring-accent-300';
export const labelCls = 'block text-xs font-medium text-foreground-600 mb-1.5';

interface ModalProps {
  title: string;
  subtitle?: string;
  onClose: () => void;
  children: ReactNode;
  footer?: ReactNode;
  maxWidth?: string;
}

export default function Modal({
  title,
  subtitle,
  onClose,
  children,
  footer,
  maxWidth = 'max-w-md',
}: ModalProps) {
  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      if (e.key === 'Escape') onClose();
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/40" onClick={onClose}></div>
      <div
        className={`relative w-full ${maxWidth} max-h-[90vh] bg-white rounded-xl border border-background-200 overflow-hidden flex flex-col`}
      >
        <div className="flex items-start justify-between px-5 py-4 border-b border-background-100">
          <div>
            <h2 className="text-base font-semibold text-foreground-950">{title}</h2>
            {subtitle && <p className="text-xs text-foreground-500 mt-0.5">{subtitle}</p>}
          </div>
          <button
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center rounded-full text-foreground-500 hover:bg-background-100 transition-colors cursor-pointer"
            aria-label="Cerrar"
          >
            <i className="ri-close-line text-lg"></i>
          </button>
        </div>

        <div className="overflow-y-auto px-5 py-5">{children}</div>

        {footer && (
          <div className="flex items-center justify-end gap-2 px-5 py-4 border-t border-background-100">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
}